  <div class="spinner">
    <fa-icon icon="spinner"></fa-icon>
    <p>{{this.message}}</p>
  </div>
